/* eslint-disable @next/next/no-img-element */
import { LogoIcon } from '@/src/assets/icons'
import * as React from 'react'
import { Divider, Typography } from '@mui/material'
import Link from 'next/link'
import dayjs from 'dayjs'

export const Footer = () => (
  <div className="flex flex-col lg:flex-row gap-5 bg-white px-8 w-full justify-between items-center">
    <div className=" md:flex items-center lg:flex-col gap-3 bg-white">
      <div className="flex items-center justify-center md:justify-start w-full gap-3">
        <Typography variant="caption" color="text.secondary">
          Powered by
        </Typography>
        <LogoIcon className="h-[20px] w-[3.589rem] fill-none" />
      </div>
      <div className="flex gap-4">
        <Typography
          variant="caption"
          color="text.secondary"
          className="md:w-[300px] md:flex md:justify-center lg:none lg:w-fit"
        >
          © {dayjs().format('YYYY')} Relait. All rights reserved.
        </Typography>
        <div className="flex items-center gap-2">
          <Typography variant="buttonLarge_sm" color="text.secondary">
            <a href="https://www.relait.com.au/privacy-policy" target="_blank">
              Privacy
            </a>
          </Typography>
          <Divider orientation="vertical" className="h-3 w-px items-center flex justify-center" />
          <Typography variant="buttonLarge_sm" color="text.secondary">
            <Link href="https://www.relait.com.au/eula" target="_blank">
              Terms
            </Link>
          </Typography>
        </div>
      </div>
    </div>
    <div className="flex gap-4 items-center"></div>
  </div>
)
